import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { RDReadyLogo } from './RDReadyLogo';
const BLUE = '#2563EB';
const TEAL = '#0F9E8E';
const links = [{
  label: 'Home',
  to: '/'
}, {
  label: 'RD Exam',
  to: '/rd-exam'
}, {
  label: 'CNSC Exam',
  to: '/cnsc-exam'
}, {
  label: 'About Us',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function RDReadyNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    user
  } = useAuth();
  return <header className="sticky top-0 z-50 border-b border-[#EDF1F7] bg-white/95 backdrop-blur" style={{
    fontFamily: '"Poppins", "Inter", system-ui, sans-serif'
  }} data-id="element-3884" data-mp="35wguq98ng3g4">
      <div className="mx-auto flex h-18 max-w-7xl items-center justify-between px-5 py-3 md:px-8" data-id="element-3885" data-mp="l455zpxl1q21">
        <Link to="/" className="shrink-0" aria-label="RD Ready home" data-id="element-3886" data-mp="g5k6jsq5naen">
          <RDReadyLogo className="h-8 w-36 sm:h-9 sm:w-40" data-id="element-3887" data-mp="2spt7iug33pvi" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary navigation" data-id="element-3888" data-mp="2xoe3uis7tpeo">
          {links.map(link => <Link key={link.label} to={link.to} className="text-sm font-medium text-[#475569] transition-colors hover:text-[#2563EB]" data-id="element-3889" data-mp="32o0k713cblrp">
              {link.label}
            </Link>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-3890" data-mp="2exd9y95yck1z">
          <Link to={user ? '/account' : '/login'} className="text-sm font-medium text-[#475569] transition-colors hover:text-[#2563EB]" data-id="element-3891" data-mp="2evsb47clueyb">
            {user ? 'Account' : 'Sign in'}
          </Link>
          <Link to="/cnsc-prep" className="rounded-full px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform hover:-translate-y-0.5" style={{
          backgroundColor: BLUE
        }} data-id="element-3892" data-mp="1r8u19sizq59d">
            Get Started
          </Link>
        </div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} className="p-2 text-[#0F172A] lg:hidden" aria-label={menuOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={menuOpen} data-id="element-3893" data-mp="1j6l1zvor58da">
          {menuOpen ? <XIcon className="h-6 w-6" data-id="element-3894" data-mp="1571v167og32k" /> : <MenuIcon className="h-6 w-6" data-id="element-3895" data-mp="159obxwggjuxg" />}
        </button>
      </div>

      {menuOpen && <nav className="border-t border-[#EDF1F7] bg-white px-5 py-4 lg:hidden" aria-label="Mobile navigation" data-id="element-3896" data-mp="10b4lpjutzwza">
          <div className="mx-auto flex max-w-7xl flex-col" data-id="element-3897" data-mp="1a5wlmubvyvx8">
            {links.map(link => <Link key={link.label} to={link.to} onClick={() => setMenuOpen(false)} className="border-b border-[#F1F5F9] py-3.5 text-sm font-medium text-[#334155]" data-id="element-3898" data-mp="2qk4wvsr7hitk">
                {link.label}
              </Link>)}
            <Link to={user ? '/account' : '/login'} onClick={() => setMenuOpen(false)} className="border-b border-[#F1F5F9] py-3.5 text-sm font-medium text-[#334155]" data-id="element-3899" data-mp="2y5i900lvkahb">
              {user ? 'Account' : 'Sign in'}
            </Link>
            <Link to="/cnsc-prep" onClick={() => setMenuOpen(false)} className="mt-4 rounded-full px-5 py-3 text-center text-sm font-semibold text-white" style={{
          backgroundColor: BLUE
        }} data-id="element-3900" data-mp="3bvu50alkytdq">
              Get Started
            </Link>
          </div>
        </nav>}
    </header>;
}